import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { Icon } from "@syarahtech/ui";
import Markdown from "markdown-to-jsx";
import { twMerge } from "tailwind-merge";
export default function FinanceWarrantyTrigger(_ref) {
  var _data$items, _items, _displaySelected$head, _displaySelected$head2, _displaySelected$head3, _displaySelected$head4, _displaySelected$head5, _displaySelected$head6, _displaySelected$head7, _displaySelected$head8, _displaySelected$head9, _displaySelected$head0;
  var data = _ref.data,
    selectedItem = _ref.selectedItem,
    onClick = _ref.onClick,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? "bg-[#F1F6FC]" : _ref$bgColor,
    _ref$titleSize = _ref.titleSize,
    titleSize = _ref$titleSize === void 0 ? "text-[13px]" : _ref$titleSize,
    _ref$subtitleSize = _ref.subtitleSize,
    subtitleSize = _ref$subtitleSize === void 0 ? "text-sm" : _ref$subtitleSize;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;

  // Don't render if items aren't ready — data.selected can be null when
  // no item is pre-selected in the API response, so guard on selectedItem instead.
  if (!(data !== null && data !== void 0 && (_data$items = data.items) !== null && _data$items !== void 0 && _data$items.length) || !selectedItem) return null;
  var items = data.items;
  var lastItemId = (_items = items[items.length - 1]) === null || _items === void 0 ? void 0 : _items.id;
  var isHighestSelected = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === lastItemId;

  // data.selected has richer display fields (icon, header); fall back to no-warranty state
  var displaySelected = data.selected;
  var isNoWarrantyState = !displaySelected;

  // For no-warranty state: find the item with a badge to feature in the subtitle
  var badgedItem = isNoWarrantyState ? items.find(function (i) {
    return !!i.badge;
  }) : null;
  var displayTitle = (_displaySelected$head = displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head2 = displaySelected.header) === null || _displaySelected$head2 === void 0 ? void 0 : _displaySelected$head2.title) !== null && _displaySelected$head !== void 0 ? _displaySelected$head : tShort("warranty/no_warranty_title", {
    ns: "web_checkout_cash"
  });

  // Subtitle: show "مدد ضمانك ل {badgedItem.title}" only if a badged item exists
  var displaySubtitle = (_displaySelected$head3 = displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head4 = displaySelected.header) === null || _displaySelected$head4 === void 0 ? void 0 : _displaySelected$head4.subtitle) !== null && _displaySelected$head3 !== void 0 ? _displaySelected$head3 : badgedItem ? "".concat(tShort("warranty/no_warranty_subtitle", {
    ns: "web_checkout_cash"
  }), " ").concat(badgedItem.title) : null;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "w-full cursor-pointer focus:outline-none "
  }, /*#__PURE__*/React.createElement("div", {
    className: "gap-1 flex items-center rounded-lg border-solid border-[1px] border-[#0D0DB5] ".concat(bgColor, " px-[6px] py-3 ")
  }, (displaySelected === null || displaySelected === void 0 ? void 0 : displaySelected.icon) && /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement("img", {
    src: displaySelected.icon,
    width: "40",
    height: "45"
  })), !(selectedItem !== null && selectedItem !== void 0 && selectedItem.is_default) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col  text-start flex-1 min-w-0"
  }, displayTitle && /*#__PURE__*/React.createElement("p", {
    className: "text-black ".concat(titleSize, " leading-6 break-words w-full text-start")
  }, (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head5 = displaySelected.header) === null || _displaySelected$head5 === void 0 ? void 0 : _displaySelected$head5.title_prefix) && /*#__PURE__*/React.createElement("span", null, displaySelected.header.title_prefix + " ")), displayTitle && /*#__PURE__*/React.createElement("p", {
    className: "".concat(selectedItem !== null && selectedItem !== void 0 && selectedItem.is_default ? "text-[12px]" : subtitleSize + "", " leading-6 break-words w-fit px-1 text-start"),
    style: _objectSpread(_objectSpread({}, (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head6 = displaySelected.header) === null || _displaySelected$head6 === void 0 ? void 0 : _displaySelected$head6.title_color) && {
      color: displaySelected.header.title_color
    }), (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head7 = displaySelected.header) === null || _displaySelected$head7 === void 0 ? void 0 : _displaySelected$head7.title_highlight_background) && {
      backgroundColor: displaySelected.header.title_highlight_background
    })
  }, /*#__PURE__*/React.createElement(Markdown, null, displayTitle)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col  text-start flex-1 min-w-0"
  }, displayTitle && /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex text-[14px] items-center leading-8 ", selectedItem !== null && selectedItem !== void 0 && selectedItem.is_default ? "pb-0.5" : "pb-1 ")
  }, (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head8 = displaySelected.header) === null || _displaySelected$head8 === void 0 ? void 0 : _displaySelected$head8.title_prefix) && /*#__PURE__*/React.createElement("span", null, displaySelected.header.title_prefix + " "), /*#__PURE__*/React.createElement("p", {
    className: "break-words w-fit px-1 text-start text-[14px]",
    style: _objectSpread(_objectSpread({}, (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head9 = displaySelected.header) === null || _displaySelected$head9 === void 0 ? void 0 : _displaySelected$head9.title_color) && {
      color: displaySelected.header.title_color
    }), (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head0 = displaySelected.header) === null || _displaySelected$head0 === void 0 ? void 0 : _displaySelected$head0.title_highlight_background) && {
      backgroundColor: displaySelected.header.title_highlight_background
    })
  }, /*#__PURE__*/React.createElement(Markdown, null, displayTitle))), displaySubtitle && /*#__PURE__*/React.createElement("p", {
    className: "text-black text-[12px] leading-6 break-words w-full text-start"
  }, /*#__PURE__*/React.createElement("span", null, displaySubtitle)))), /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, isHighestSelected && !isNoWarrantyState ? /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--edit-square-outline",
    className: "text-primary-new px-1",
    width: 5,
    height: 5
  }) : /*#__PURE__*/React.createElement("div", {
    className: "flex gap-1 rounded-[4px] bg-primary-new px-1 py-2 items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-white text-[11px] leading-tight whitespace-nowrap"
  }, tShort("warranty/extend_now")), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add",
    className: "text-white px-1",
    width: 4,
    height: 4
  })))));
}